import { z } from 'zod'
import { widgetSchema } from '../../common/schema'
import { spacesParamsSchema } from './data'

// Old WP `[homerunner-property-spaces]` parity: a per-room card grid listing
// each room's bed configuration (King, Double, 2 Single, …).
export const spacesWidgetConfig = widgetSchema.extend({
  section: z.object({
    show: z.boolean().default(false).describe('Show the section title above the widget content'),
    title: z.string().nullish().default('Sleeping Arrangements').describe('Section title text'),
  }).default({ show: false, title: 'Sleeping Arrangements' }).describe('Section heading shown above the widget content'),
  filter: spacesParamsSchema,
  columns: z.object({
    sm: z.number().int().min(1).max(6).default(1).describe('Columns on small screens'),
    md: z.number().int().min(1).max(6).default(2).describe('Columns on medium screens'),
    lg: z.number().int().min(1).max(6).default(3).describe('Columns on large screens'),
  }).default({ sm: 1, md: 2, lg: 3 }).describe('Card grid columns per breakpoint'),
  showRoomIcon: z.boolean().default(true).describe('Show an icon next to each room title'),
  roomIcon: z.string().default('icon-beds').describe('Icon class for each room (icomoon)'),
  showBedIcon: z.boolean().default(true).describe('Show an icon on each bed line (WP property-spaces parity)'),
  bedIcon: z.string().default('icon-beds').describe('Icon class for each bed line (icomoon)'),
  showTotalBeds: z.boolean().default(false).describe('Show the total bed count per room'),
  noItemsText: z.string().nullish().default('No room details available.').describe('Message shown when the property has no room data'),
  // dashboard#1420 PR B — widget parity for the toolkit's bedroom-showcase
  // photo slots (bedroomNimage/bedroomNdetails operator-imported custom
  // fields). Field-gated regardless of this setting: a bedroom card only
  // grows a photo/details block when the property actually has a matching
  // imported field. Default on, matching the toolkit's own zero-config
  // behavior (no per-site opt-in there either).
  showBedroomMedia: z.boolean().default(true).describe('Show imported bedroom photos and blurbs (toolkit bedroom-showcase parity) on bedroom-type rooms'),
  // dashboard#1707 — toolkit bedroom-showcase 3.244.0-3.247.0 parity. Defaults
  // are the toolkit's own (Page::DEFAULTS caption_matching '0',
  // slideshow_transition 'fade'). Both only act while showBedroomMedia is on.
  matchBedroomCaptions: z.boolean().default(false).describe('Fill bedrooms that have no photo field from the property photos whose captions name the room (and its ensuite). Reads the property photos the Gallery widget on the same page already loaded; adds no request of its own'),
  bedroomSlideshowTransition: z.enum(['fade', 'slide', 'none']).default('fade').describe('How a bedroom card with several photos changes photo: fade, slide, or none (instant)'),
})

export type SpacesWidgetConfig = z.infer<typeof spacesWidgetConfig>
